<template>
	<hyper-cloud-console
		:api="api"
		:autoOpen="autoOpen"
		:hideControls="hideControls"
		:customui="customui"
		@userdataloaded="onUserDataLoaded"
		@accessgranted="onAccessGranted"
		@themechanged="onThemeChanged"
		@accessdenied="onAccessDenied"
		ref="console"
	></hyper-cloud-console>
</template>

<script>
//eslint-disable-next-line
import HyperCloudConsole from 'hyper-cloud-console';
import { API_PATH } from '../../../config/config';
import Request from '../../services/request';
import ConsoleService from '../../services/console';
import ThemeService from '../../services/theme';
import { mapActions } from 'vuex';

export default {
	name: 'HyperCloudConsoleVue',
	props: ['autoOpen', 'hideControls', 'customui'],
	data() {
		// trick the linter's unused warning check.
		HyperCloudConsole;
		return {
			api: API_PATH,
			theme: 'light',
		};
	},
	mounted() {
		ConsoleService.instance().setConsole(this.$refs.console);
		this.setTokenData(this.$refs.console.getTokenDetails());

		Request.instance().events.on('expire', () =>
			this.$refs.console.refreshToken(),
		);
	},
	methods: {
		...mapActions({
			setAuthenticatedUserData: 'setAuthenticatedUserData',
			setTokenData: 'setTokenData',
			clearAuthData: 'clearAuthData',
			setConsoleReady: 'setConsoleReady',
		}),
		onAccessGranted(event) {
			this.setTokenData(event.detail).then(() =>
				Request.instance().redoDenied(),
			);
		},
		onUserDataLoaded(event) {
			const user = event.detail;
			if (user.params) {
				this.theme = user.params.theme;
			}
			ThemeService.instance().setTheme(this.theme);

			this.setAuthenticatedUserData({
				user: user,
				canNavigate: this.$refs.console.canNavigate,
				isAdmin: this.$refs.console.isAdmin(),
				isDeveloper: this.$refs.console.currentUserHasAuthority('ROLE_DEV'),
			}).finally(() => this.setConsoleReady());
		},
		onThemeChanged(event) {
			this.theme = event.detail;
			ThemeService.instance().setTheme(this.theme);
		},
		onAccessDenied() {
			this.clearAuthData().finally(() => this.setConsoleReady());
		},
	},
};
</script>

<style scoped>
.hidden-console {
	visibility: hidden;
}
</style>
